import React, {Component} from 'react';
import couterpart from 'counterpart';
import { withRouter } from 'react-router-dom'
import {ToastsContainer, ToastsStore} from 'react-toasts';

import MenuComponent2 from './MenuComponent2';
import ShopDataService from '../services/ShopDataService';

import '../css/style.css';
import {TiArrowBackOutline} from 'react-icons/ti';
import {FaRegSave} from 'react-icons/fa';
import { ICON_COLOR } from '../icon';

class ShopDetailsEdit extends Component {
    constructor() {
        super();
        this.state = {
            name:'',
            description:'',
            pcode: 0,
            pre: '',
            updated: null,
            msg:''
        } 
    };

    componentDidMount () {
        const { id } = this.props.match.params;
        if ((id === undefined) || (id === null)) {
            return;
        }

        ShopDataService.retrieveById(`${id}`).then(data => {
            this.setState({ 
                id: id,  
                name:data.name,
                description:data.description,
                pcode: data.pcode,
                pre: data.pre,
                msg: ''
            });
        });
    }

    handleChange(e){
        var name = e.target.name;
        var value = e.target.value;
        this.setState({ [name]:  value});
    }

    handleNumChange(e){
        var name = e.target.name;
        var value = e.target.value;
        this.setState({ [name]:  parseInt(value)});
    }

    handleSave(){
        var msg = "";
        if ((this.state.name === undefined) || 
            (this.state.name ===null) || 
            (this.state.name.length < 1)){
                const msg_shop_name_missing = couterpart.translate('msg_shop_name_missing');
                ToastsStore.error(msg_shop_name_missing);
                return;
        }

        if ((this.state.id != null) && (this.state.id > 0)){
            ShopDataService.update(this.state).then(data => {
                msg = couterpart.translate("msg_shop_update_ok");
                this.setState({msg: msg},()=>{
                    this.backToList();
                });
            });
        }else{
            ShopDataService.save(this.state).then(data => {
                msg = couterpart.translate("msg_shop_create_ok");
                this.setState({name: data.name, msg: msg}, ()=>{
                    this.backToList();
                });
            });
        }
    }

    backToList(){
        this.props.history.push("/shops");
    }
      
    render() {
        return (
            <div>
                <MenuComponent2/>
                <ToastsContainer store={ToastsStore} position="bottom_center" />
                <div style={{padding:"5px"}}>
                <button className="myButton" onClick={this.backToList.bind(this)}>
                        <TiArrowBackOutline color={ICON_COLOR}/>&nbsp;
                        {couterpart.translate('button_back')}&nbsp;&nbsp;&nbsp;&nbsp;</button>
                </div>
                <div>
                    <br/><br/><br/>
                    <table width="50%" border="0" align="center">
                        <tbody>                       
                        <tr>
                            <td><b>*{couterpart.translate('shop_name')}</b></td>
                            <td><input name="name" 
                                type="text" placeholder="" defaultValue={this.state.name}
                                onChange={this.handleChange.bind(this)}/></td>
                        </tr>
                        <tr>
                            <td><b>{couterpart.translate('shop_desc')}</b></td>
                            <td><input name="description" type="text" 
                                placeholder="" defaultValue={this.state.description}
                                onChange={this.handleChange.bind(this)}/></td>
                        </tr>
                        <tr>
                            <td><b>{couterpart.translate('shop_pcode')}</b></td>
                            <td><input name="pcode" type="number" 
                                placeholder="" value={this.state.pcode}
                                onChange={this.handleChange.bind(this)}/></td>
                        </tr>
                        <tr>
                            <td><b>*{couterpart.translate('shop_pre')}</b></td>
                            <td><input name="pre" type="text" 
                                placeholder="" defaultValue={this.state.pre}
                                onChange={this.handleChange.bind(this)}/></td>
                        </tr>                                                                                                                   
                        <tr>
                            <td>&nbsp;</td>
                            <td><button  className="myButton" 
                            onClick={this.handleSave.bind(this)}>
                            <FaRegSave color={ICON_COLOR}/>&nbsp;
                            {couterpart.translate('button_save')}</button></td>
                            <td>{this.state.msg}</td>
                        </tr>                                                                                              
                        </tbody>
                    </table>                    
                </div>
            </div>
        );
    }
}

export default withRouter(ShopDetailsEdit);